import { trpc } from '@/lib/trpc';

const useScrap = () => {
	const { mutate, isPending, error } = trpc.wish.scrap.useMutation();

	return {
		scrap: mutate,
		scrapLoading: isPending,
		scrapError: error,
	};
};

export default useScrap;
